<template>
  <v-list-item>
    <v-list-item-content>
      <h2 class="title">Documento {{ index + 1 }}</h2>
      <v-combobox
        v-model="doc.tipo_documento"
        item-value="id"
        label="Tipo de documento"
        :items="tiposPermitidos"
        no-data-text="Nenhum tipo disponível para este arquivo"
        :error-messages="
          !doc.tipo_documento ? 'Informe o tipo de documento' : ''
        "
      >
        <template v-slot:selection="{ item }">
          <v-list-item-content>
            <v-list-item-title>{{ item.descricao }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ strTipos(item) }} -
              {{ tamanhoMaximo(item) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title>{{ item.descricao }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ strTipos(item) }} -
              {{ tamanhoMaximo(item) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-combobox>
      <v-text-field
        v-model="arquivoNome"
        label="Nome do arquivo"
        :suffix="arquivoExtensao"
        :counter="arquivoMaxLength"
        :maxlength="arquivoMaxLength"
        :error-messages="arquivoNome === '' ? 'Informe o nome do arquivo' : ''"
      />
      <v-text-field
        v-model="doc.registro"
        label="Registro"
        counter="50"
        maxlength="50"
        hint="Identificação do documento (Nº do CPF/CNPJ, identificação de contratos, etc)"
        persistent-hint
        :error-messages="
          doc.registro === ''
            ? 'Informe o registro identificador do documento'
            : ''
        "
      />
      <v-menu
        v-model="menuDataValidade"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dataValidade"
            label="Data de validade"
            prepend-icon="mdi mdi-calendar"
            readonly
            v-on="on"
            clearable
          ></v-text-field>
        </template>
        <button-datepicker
          v-model="doc.data_validade"
          @input="menuDataValidade = false"
        />
      </v-menu>
      <div class="text-right">
        <v-btn
          text
          color="error"
          @click="$emit('remover')"
          title="Cancelar inserção de documento"
        >
          <v-icon>mdi-cancel</v-icon>CANCELAR
        </v-btn>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import ButtonDatepicker from "../ButtonDatepicker";
export default {
  components: { ButtonDatepicker },
  props: ["value", "urlBase", "index", "adicionados", "adicionando"],
  data() {
    return {
      menuDataValidade: false,
      doc: _.clone(this.value),
    };
  },
  computed: {
    mimeTypes() {
      const tipos = [];
      for (let t of this.doc.tipo_documento.tipos_permitidos) {
        switch (t) {
          case "imagem":
            tipos.push("image/*");
            break;
          case "audio":
            tipos.push("audio/mpeg");
            break;
          case "pdf":
            tipos.push("application/pdf");
            break;
          case "word":
            tipos.push(
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            );
            break;
          case "excel":
            tipos.push(
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            );
            break;
        }
      }
      return tipos.join(",");
    },
    arquivoExtensao() {
      return "." + this.doc.nome_original.split(".").pop();
    },
    arquivoNome: {
      get() {
        return this.doc.nome_original.substr(
          0,
          this.doc.nome_original.length - this.arquivoExtensao.length
        );
      },
      set(val) {
        this.doc.nome_original = val + this.arquivoExtensao;
      },
    },
    arquivoMaxLength() {
      return 255 - this.arquivoExtensao.length;
    },
    dataValidade() {
      return this.doc.data_validade
        .split("-")
        .reverse()
        .join("/");
    },
    tiposPermitidos() {
      const tipos = JSON.parse(
        JSON.stringify(this.$store.state.documento.tiposPermitidos)
      );
      return tipos
        .filter((t) => {
          const naoTem = !this.adicionados
            .filter((a) => !a.remover)
            .map((a) => a.id_tipo_documento)
            .includes(t.id);

          const naoTera = !this.adicionando
            .filter(
              (a) =>
                a.tipo_documento &&
                a.tipo_documento.id != this.doc.id_tipo_documento
            )
            .map((a) => a.tipo_documento.id)
            .includes(t.id);

          return naoTem && naoTera;
        })
        .map((t) => {
          if (this.doc.arquivo.size / 1024 / 1024 > t.tamanho_maximo) {
            t.disabled = true;
          }

          let tipo = "";
          if (this.doc.arquivo.type.substr(0, 5) === "image") {
            tipo = "imagem";
          } else if (this.doc.arquivo.type === "audio/mpeg") {
            tipo = "audio";
          } else if (this.doc.arquivo.type === "application/pdf") {
            tipo = "pdf";
          } else if (
            this.doc.arquivo.type === "application/msword" ||
            this.doc.arquivo.type ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            tipo = "word";
          } else if (
            this.doc.arquivo.type === "application/vnd.ms-excel" ||
            this.doc.arquivo.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            tipo = "excel";
          }

          if (!t.tipos_permitidos.includes(tipo)) {
            t.disabled = true;
          }

          return t;
        });
    },
  },
  mounted() {
    this.$store.dispatch("documento/listarTiposPermitidos", this.urlBase);
  },
  methods: {
    strTipos(tipo) {
      return tipo.tipos_permitidos
        .map((t) => {
          switch (t) {
            case "imagem":
              return "Imagens";
            case "pdf":
              return "PDF";
            case "excel":
              return "Planilhas Excel";
            case "word":
              return "Documento Word";
            case "audio":
              return "Áudio MP3";
          }
        })
        .join(", ");
    },
    tamanhoMaximo(tipo) {
      return `Tamanho máximo ${tipo.tamanho_maximo} MB`;
    },
  },
  watch: {
    doc: {
      deep: true,
      handler(doc) {
        doc.valido =
          doc.tipo_documento && this.arquivoNome !== "" && doc.registro !== "";

        if (doc.data_validade != "") {
          doc.dias_vencimento = moment(
            doc.data_validade + "T23:59:59.000Z"
          ).diff(moment(), "days");
        }
        this.$emit("input", doc);
      },
    },
  },
};
</script>
